import { getRequestAccessApiUrl } from '../../api';

function getGoogleSingInUrl(accessId: string) {
    const params = {
        connectType: 'GOOGLE_GRANT_ACCESS',
        sendBackToUrl: window.location.href,
        accessRequestFormAccessId: accessId,
    };

    const searchParams = new URLSearchParams(params);

    const googleConnectUrl = `${getRequestAccessApiUrl()}/oauth2/google/start`;

    return `${googleConnectUrl}?${searchParams}`;
}

export { getGoogleSingInUrl };
